/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var tooltip_triggers = document.querySelectorAll('.mowgli-tooltip-container button'),
      opened_tooltip_container = false;

  if(tooltip_triggers) {
    tooltip_triggers.forEach((tooltip_trigger) => {
      var tooltip_container = document.getElementById(tooltip_trigger.getAttribute('id') + '-reg'),
          tooltip_timeout;

      tooltip_trigger.addEventListener('mouseenter', () => {
        tooltip_timeout = setTimeout(() => {
          tooltip_container.classList.add('open');
          opened_tooltip_container = tooltip_container;
        }, 400);
      });

      tooltip_trigger.addEventListener('mouseleave', () => {
        clearTimeout(tooltip_timeout);
        tooltip_container.classList.remove('open');
        opened_tooltip_container = false;
      });

      tooltip_trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        tooltip_container.classList.toggle('open');

        if(opened_tooltip_container && tooltip_container !== opened_tooltip_container) {
          opened_tooltip_container.classList.remove('open');
        }

        opened_tooltip_container = tooltip_container;
      });

      tooltip_container.addEventListener('keydown', function(e) {
        if(e.code === 'Escape') {
          return;
        }

        if(e.code === 'Enter') {
          e.preventDefault();
          opened_tooltip_container.classList.toggle('open');
        }

        e.stopPropagation();
      });
    });

    document.querySelector('body').addEventListener('keydown', function(e) {
      if(!opened_tooltip_container) {
        return;
      }

      if(e.code === 'Escape') {
        e.preventDefault();
        opened_tooltip_container.classList.remove('open');
        opened_tooltip_container = false;
      }
    });
  }
}());